
import React from "react";
import { Guest } from "@/data/mockData";
import GuestCard from "./GuestCard";
import { Plus, User as UserIcon } from "lucide-react";

interface UpcomingGuestsProps {
  guests: Guest[];
  onAddGuest?: () => void;
}

const UpcomingGuests: React.FC<UpcomingGuestsProps> = ({ 
  guests,
  onAddGuest 
}) => {
  const upcomingGuests = guests.filter(
    guest => guest.status === 'scheduled' || guest.status === 'pending'
  );

  return (
    <div className="bg-background rounded-xl overflow-hidden p-6 border border-border/30 shadow-sm animate-enter">
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-medium text-foreground">
          Upcoming Guests <span className="text-muted-foreground font-normal">({upcomingGuests.length})</span>
        </h2>
        <button 
          onClick={onAddGuest}
          className="inline-flex items-center text-sm font-medium bg-primary/10 text-primary hover:bg-primary/20 px-3 py-1.5 rounded-lg transition-colors"
        >
          <Plus className="w-4 h-4 mr-1.5" />
          New Guest
        </button>
      </div>

      <div className="grid grid-cols-1 gap-6">
        {upcomingGuests.length > 0 ? (
          upcomingGuests.map(guest => (
            <GuestCard key={guest.id} guest={guest} />
          ))
        ) : (
          <div className="flex flex-col items-center justify-center py-12 text-center">
            <div className="w-16 h-16 rounded-full bg-muted flex items-center justify-center mb-4">
              <UserIcon className="w-8 h-8 text-muted-foreground/60" />
            </div>
            <h3 className="text-lg font-medium text-foreground mb-1">No upcoming guests</h3>
            <p className="text-muted-foreground max-w-md">
              You don't have any scheduled or pending guests. 
              Start by adding a new guest to your roster.
            </p>
            <button 
              onClick={onAddGuest}
              className="mt-4 inline-flex items-center text-sm font-medium bg-primary text-primary-foreground hover:bg-primary/90 px-4 py-2 rounded-lg transition-colors"
            >
              <Plus className="w-4 h-4 mr-1.5" />
              Add Your First Guest
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default UpcomingGuests;
